<template>
  <footer class="w-full bg-[#2e234b] text-white">
    <div class="mx-auto w-full max-w-[1366px] px-6 py-8">
      <!-- Main Footer Content -->
      <div
        class="flex flex-col gap-8 md:flex-row md:items-start md:justify-between"
      >
        <!-- LEFT: Logo and Company Info -->
        <div class="flex flex-col items-start gap-4">
          <div class="flex flex-col items-start gap-[2px]">
            <img
              src="/images/logo_color.svg"
              alt="Upfest logo"
              class="h-9 w-auto brightness-0 invert filter"
            />
            <span
              class="text-[13px] font-extrabold uppercase leading-none tracking-[0.08em] text-white"
              >Upfest</span
            >
          </div>
          <p class="max-w-sm text-sm text-gray-300">
            {{ $t("footer.description") }}
          </p>
        </div>

        <!-- CENTER: Navigation Links (Desktop) -->
        <nav class="hidden flex-col gap-8 md:flex md:flex-row">
          <div class="flex flex-col gap-3">
            <h3 class="text-sm font-semibold uppercase tracking-wide">
              {{ $t("footer.platform") }}
            </h3>
            <div class="flex flex-col gap-2">
              <NuxtLink
                :to="localePath('/events')"
                class="text-left text-sm text-gray-300 transition-colors hover:text-white"
              >
                {{ $t("footer.findEvents") }}
              </NuxtLink>
              <NuxtLink
                :to="localePath('/venues')"
                class="text-left text-sm text-gray-300 transition-colors hover:text-white"
              >
                {{ $t("footer.findPlaces") }}
              </NuxtLink>
              <NuxtLink
                :to="localePath('/how-it-works')"
                class="text-left text-sm text-gray-300 transition-colors hover:text-white"
              >
                {{ $t("footer.howItWorks") }}
              </NuxtLink>
            </div>
          </div>

          <div class="flex flex-col gap-3">
            <h3 class="text-sm font-semibold uppercase tracking-wide">
              {{ $t("footer.legal") }}
            </h3>
            <div class="flex flex-col gap-2">
              <NuxtLink
                :to="localePath('/privacy')"
                class="text-sm text-gray-300 transition-colors hover:text-white"
              >
                {{ $t("footer.privacy") }}
              </NuxtLink>
              <NuxtLink
                :to="localePath('/terms')"
                class="text-sm text-gray-300 transition-colors hover:text-white"
              >
                {{ $t("footer.terms") }}
              </NuxtLink>
              <NuxtLink
                :to="localePath('/imprint')"
                class="text-sm text-gray-300 transition-colors hover:text-white"
              >
                {{ $t("footer.imprint") }}
              </NuxtLink>
            </div>
          </div>
        </nav>

        <!-- RIGHT: Contact/Actions -->
      </div>

      <nav class="mt-8 border-t border-white/10 pt-8 md:hidden">
        <div class="grid grid-cols-2 gap-4">
          <div class="flex flex-col gap-3">
            <h3 class="text-sm font-semibold uppercase tracking-wide">
              {{ $t("footer.platform") }}
            </h3>
            <NuxtLink
              :to="localePath('/events')"
              class="text-left text-sm text-gray-300 transition-colors hover:text-white"
            >
              {{ $t("footer.findEvents") }}
            </NuxtLink>
            <NuxtLink
              :to="localePath('/venues')"
              class="text-left text-sm text-gray-300 transition-colors hover:text-white"
            >
              {{ $t("footer.findPlaces") }}
            </NuxtLink>
            <NuxtLink
              :to="localePath('/how-it-works')"
              class="text-left text-sm text-gray-300 transition-colors hover:text-white"
            >
              {{ $t("footer.howItWorks") }}
            </NuxtLink>
            <!-- <NuxtLink :to="localePath('/roadmap')"
                            class="text-sm text-gray-300 hover:text-white transition-colors text-left">
                            {{ $t('footer.roadmap') }}
                        </NuxtLink> -->
          </div>

          <div class="flex flex-col gap-3">
            <h3 class="text-sm font-semibold uppercase tracking-wide">
              {{ $t("footer.legal") }}
            </h3>
            <NuxtLink
              :to="localePath('/privacy')"
              class="text-left text-sm text-gray-300 transition-colors hover:text-white"
            >
              {{ $t("footer.privacy") }}
            </NuxtLink>
            <NuxtLink
              :to="localePath('/terms')"
              class="text-left text-sm text-gray-300 transition-colors hover:text-white"
            >
              {{ $t("footer.terms") }}
            </NuxtLink>
            <NuxtLink
              :to="localePath('/imprint')"
              class="text-left text-sm text-gray-300 transition-colors hover:text-white"
            >
              {{ $t("footer.imprint") }}
            </NuxtLink>
          </div>
        </div>
      </nav>

      <!-- Bottom Bar -->
      <div
        class="mt-8 flex flex-col gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between"
      >
        <div class="space-y-1 text-xs text-gray-400">
          <p>{{ $t("footer.allRightsReserved", { year: currentYear }) }}</p>
          <p>{{ $t("footer.brandRelationship") }}</p>
        </div>
        <div class="flex flex-wrap items-center gap-4">
          <NuxtLink
            :to="localePath('/imprint')"
            class="text-xs text-gray-400 transition-colors hover:text-white"
          >
            {{ $t("footer.imprint") }}
          </NuxtLink>
          <NuxtLink
            :to="localePath('/privacy')"
            class="text-xs text-gray-400 transition-colors hover:text-white"
          >
            {{ $t("footer.privacy") }}
          </NuxtLink>
          <NuxtLink
            :to="localePath('/terms')"
            class="text-xs text-gray-400 transition-colors hover:text-white"
          >
            {{ $t("footer.terms") }}
          </NuxtLink>
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from "vue";

const currentYear = computed(() => new Date().getFullYear());

const localePath = useLocalePath();
</script>
